export default {

}



// WEBPACK FOOTER //
// ./src/components/bank/store/state.js